import AddressesContainer from './AddressesContainer';

export default AddressesContainer;
export { AddressesProvider, useAddressesContext, ADDRESSES_TABS } from './AddressesContext';
